import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'arrayFilter',
    standalone: false
})
export class ArrayFilterPipe implements PipeTransform {

  filter(items, options) {
    const itemSecondary = (item1, keyPath) => {
      function index(obj, i) {
        if (obj) {return obj[i];}
      }

      if (keyPath) {return keyPath.split('.').reduce(index, item1);}
    };

    if (!options.filterArray) {
      return items;
    }

    let filtered = items;

    options.filterArray.forEach((filterConfig) => {

      const keyPath = filterConfig.keyPath;
      const filterByKeyPath = filterConfig.filterByKeyPath;

      filtered = filtered.filter((item) => {
        if (
          keyPath === undefined
          || (
            filterByKeyPath === undefined
            && filterConfig.filterByProperty === undefined
            && filterConfig.filterByRegExp === undefined
          )) {
          return true;
        }
        else if (itemSecondary(item, keyPath) === filterConfig.filterByProperty) {
          return true;
        }
        else if (filterConfig.filterByRegExp !== undefined
          && (itemSecondary(item, keyPath) + '').toString().search(filterConfig.filterByRegExp) !== -1) {
          return true;
        }
      });
    });


    return filtered;
  }

  transform(value: any, args?: any): any {
    return this.filter(value, args);
  }

}
